import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';

import { callConfirm } from '../../../services/cofidis/actions';

import ButtonComponent from '../../button/ButtonComponent';
import { LoadingComponent } from '../../loading/LoadingComponent';

import { CofidisIframeContainer } from './CofidisIframeStyle';

const CofidisIframe = ({
    order,
    history,
    requestId,
    merchantTransactionId,
    initialize,
    fetchingConfirm,
    confirm
}) => {
    const [confirmed, setConfirmed] = useState(0);
    const [block, setBlock] = useState();
    const [buttonLabel, setButtonLabel] = useState('Suivant');
    const [showLegalForm, setShowLegalForm] = useState(false);
    const [isLegalFormDisplayed, setIsLegalFormDisplayed] = useState(false);
    const [validPaiement, setValidPaiement] = useState(false);
    const [waitTransaction, setWaitTransaction] = useState(false);

    useEffect(() => {
        createFormCofidis();
    }, []);

    useEffect(() => {
        if (showLegalForm) {
            createLegalForm();
        }
    }, [showLegalForm]);

    // Handle payment confirm
    useEffect(() => {
        if (fetchingConfirm) {
            setConfirmed(1);
        }
        if (confirmed === 1) {
            if (confirm) {
                history.push(`${PATH.EBON_CONFIRMATION_PATH}?orderId=${order.id}`);
            } else {
                history.push(`${PATH.EBON_ERROR_PATH}-${order.id}`);
            }
        }
    }, [fetchingConfirm]);

    const createFormCofidis = () => {
        document.querySelectorAll('iframe').forEach(e => e.remove());

        if (!document.querySelector('iframe')) {
            var block = new window.papi.EFBlock({
                sessionToken: initialize,
                hostElement: document.getElementById('EFBlock'),
                iframeWidth: '100%',
                iframeHeight: '1000',
                customization: {
                    partnerSideNextButton: true,
                    designLink: 'logo',
                    mode: '4step'
                }
            });

            block.addEventListener('decision', function(decision) {
                if (decision === 'accepted') {
                    sendConfirm();
                } else if (decision === 'refused') {
                    history.push(`${PATH.EBON_ERROR_PATH}-${order.id}`);
                }
            });
            block.addEventListener('stepchange', function(step) {
                if (step === 'customer-info') {
                }
                if (step === 'customer-birth-info') {
                    block.iframe.height = '575';
                }
                if (step === 'legal-notices') {
                    setShowLegalForm(true);
                    setButtonLabel("J'accepte");
                    block.iframe.height = '480';
                }
                if (step === 'payment') {
                    setShowLegalForm(false);
                    setButtonLabel('Payer');
                }
            });

            block.addEventListener('change', function(canValidate) {
                setValidPaiement(canValidate.canValidate);
            });
            setBlock(block);
        }
        return true;
    };

    const createLegalForm = () => {
        if (document.querySelector('iframe') && !isLegalFormDisplayed) {
            new window.papi.EFLegalFootnotes({
                sessionToken: initialize,
                blockFrame: block,
                hostElement: document.getElementById('legalFormContainer'),
                iframeWidth: '100%',
                iframeHeight: '730'
            });
            setIsLegalFormDisplayed(true);
        }
    };

    const sendConfirm = () => {
        const data = {
            requestId: requestId,
            merchantTransactionId: merchantTransactionId
        };

        return callConfirm(data);
    };

    return (
        <CofidisIframeContainer>
            <div id="EFBlock"></div>

            <ButtonComponent
                color="main"
                cssClass="nextStepButton"
                text={!waitTransaction && buttonLabel}
                onClick={() => {
                    if (validPaiement) {
                        setWaitTransaction(true);
                    }
                    block.next();
                }}
            />

            {waitTransaction && (
                <div className="loading">
                    <LoadingComponent />
                </div>
            )}

            <div id="legalFormContainer"></div>
        </CofidisIframeContainer>
    );
};

CofidisIframe.propTypes = {
    order: PropTypes.object
};

const mapStateToProps = state => {
    return {
        requestId: state.cofidis.requestId,
        merchantTransactionId: state.cofidis.merchantTransactionId,
        initialize: state.cofidis.initialize,
        fetchingConfirm: state.cofidis.fetchingConfirm,
        confirm: state.cofidis.confirm
    };
};

export default connect(mapStateToProps)(CofidisIframe);



// WEBPACK FOOTER //
// ./src/components/iframes/cofidis/CofidisIframe.js